export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.964.218a.745.745 0 011.054 0l4.473 4.473-1.054 1.054L5.49 1.8 1.545 5.745.491 4.691 4.964.218z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "11",
    "height": "6",
    "viewBox": "0 0 11 6",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};